export const getBusinessById = async (businessId: string, partnerId: string): Promise<any> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/parafin/token/${businessId}?partner_id=${partnerId}`
  );

  if (!response.ok) {
    throw new Error(
      `Error trying to obtain business information`
    );
  }

  const data = await response.json()
  return data.token
};
